import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const initialState = {
  isLoading: false,
  error: null,
  courier: {},
  courierList: [],
};

const slice = createSlice({
  name: 'courier',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCourierSuccess(state, action) {
      state.isLoading = false;
      state.courierList = action.payload;
    },

    getCourierByIdSuccess(state, action) {
      state.isLoading = false;
      state.courier = action.payload;
    },

    addCourierSuccess(state, action) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

export function getCouriers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/admin/couriers');
      dispatch(slice.actions.getCourierSuccess(response?.data || []));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCourierById(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/admin/courier/${id}`);
      dispatch(slice.actions.getCourierByIdSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addCourier(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/admin/couriers', data);
      dispatch(slice.actions.addCourierSuccess(response.data));
      return { payload: {} };
    } catch (error) {
      console.log('error');
      const errorMessage =
        error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  };
}

export function updateCourier(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/api/admin/courier/${id}`, data);
      dispatch(slice.actions.addCourierSuccess(response.data));
      return { payload: {} };
    } catch (error) {
      console.log('error');
      const errorMessage =
        error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  };
}

export function deleteCourier(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(`/api/admin/courier/${id}`);
      dispatch(slice.actions.addCourierSuccess(response.data));
      return { payload: {} };
    } catch (error) {
      console.log('error');
      const errorMessage =
        error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  };
}
